/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type IssueLineRichMenuBackgroundImageUploadUrlInput = {
  fileExtension: string;
};

export type IssueLineRichMenuBackgroundImageUploadUrlMutationVariables = Exact<{
  input: Types.IssueLineRichMenuBackgroundImageUploadUrlInput;
}>;


export type IssueLineRichMenuBackgroundImageUploadUrlMutation = { issueLineRichMenuBackgroundImageUploadUrl: { uploadUrl: string, fileName: string } };


export const IssueLineRichMenuBackgroundImageUploadUrlDocument = gql`
    mutation issueLineRichMenuBackgroundImageUploadUrl($input: IssueLineRichMenuBackgroundImageUploadUrlInput!) {
  issueLineRichMenuBackgroundImageUploadUrl(input: $input) {
    uploadUrl
    fileName
  }
}
    `;

/**
 * __useIssueLineRichMenuBackgroundImageUploadUrlMutation__
 *
 * To run a mutation, you first call `useIssueLineRichMenuBackgroundImageUploadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueLineRichMenuBackgroundImageUploadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueLineRichMenuBackgroundImageUploadUrlMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIssueLineRichMenuBackgroundImageUploadUrlMutation(options: VueApolloComposable.UseMutationOptions<IssueLineRichMenuBackgroundImageUploadUrlMutation, IssueLineRichMenuBackgroundImageUploadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueLineRichMenuBackgroundImageUploadUrlMutation, IssueLineRichMenuBackgroundImageUploadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueLineRichMenuBackgroundImageUploadUrlMutation, IssueLineRichMenuBackgroundImageUploadUrlMutationVariables>(IssueLineRichMenuBackgroundImageUploadUrlDocument, options);
}
export type IssueLineRichMenuBackgroundImageUploadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueLineRichMenuBackgroundImageUploadUrlMutation, IssueLineRichMenuBackgroundImageUploadUrlMutationVariables>;